import { all, put, takeEvery, take } from 'redux-saga/effects';
import { AML_QUIZ_MODAL, AML_SUCCESS_MODAL, AML_QUIZ_FORM } from '../constants';
import { openModal, closeModal } from 'components/TP-UI/TPModal/actions';
import * as actionCreators from '../actions';
import { logoutSuccess, logoutAsCurrentUser } from '../../auth/actions';
import { clearCompleteAML } from '../actions';
import { stopSubmit } from 'redux-form';
import { signinAsUserSuccess } from '../../userManagement/pages/UserDetails/actions';

function* handleAMLAnswersSuccess() {
  yield put(closeModal(AML_QUIZ_MODAL));
  yield put(openModal(AML_SUCCESS_MODAL));
}
function* handleAMLAnswersFail() {
  yield put(
    stopSubmit(AML_QUIZ_FORM, {
      _error: { key: 'errors.notifications.unexpectedError' },
    }),
  );
}

function* clearCompleteAMLState() {
  yield put(clearCompleteAML());
}

function* waitLoginClearCompleteAMLState() {
  yield take(signinAsUserSuccess);
  yield put(clearCompleteAML());
}

export default function* watchRequest() {
  yield all([
    takeEvery(actionCreators.sendAmlAnswersSuccess, handleAMLAnswersSuccess),
    takeEvery(actionCreators.sendAmlAnswersFail, handleAMLAnswersFail),
    takeEvery(logoutSuccess, clearCompleteAMLState),
    takeEvery(logoutAsCurrentUser, waitLoginClearCompleteAMLState),
  ]);
}
